/*
 * @Author: hzm
 * @Date: 2022-12-14 14:12:50
 * @Description:
 */
/*
 * @Author: hzm
 * @Date: 2022-06-29 10:32:31
 * @Description:
 */
import http from '@/utils/request';

// 查询消息组列表
export function listMsgPush(query: ObjType) {
  return http.request<API.MsgPush>({
    url: '/system/msgSend/list',
    method: 'get',
    params: query,
  });
}

export function addMsgPush(data: ObjType) {
  return http.request<API.MsgPush>({
    url: '/system/msgSend/addMsgSend',
    method: 'post',
    data,
  });
}

export function delMsgPush(ids: Ids) {
  return http.request<API.MsgPush>({
    url: '/system/msgSend/' + ids,
    method: 'delete',
  });
}

// 获取消息

export function listForUser(query: ObjType) {
  return http.request<API.MsgPush>({
    url: '/system/msgSend/listForUser',
    method: 'get',
    params: query,
  });
}

export function readMsg(data: ObjType) {
  return http.request<API.MsgPush>({
    url: '/system/msgSend/readMsg',
    method: 'put',
    params: data,
  });
}

export function readAllMsg() {
  return http.request<API.MsgPush>({
    url: '/system/msgSend/readAllMsg',
    method: 'put',
  });
}

export function getMsgPush(ids: Ids) {
  return http.request<API.MsgPush>({
    url: '/system/msgSend/' + ids,
    method: 'get',
  });
}
